import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function stack(theme: Theme) {
  return {
    MuiStack: {
      styleOverrides: {
        root: {
          marginBottom: '0 !important'
        },
      },
    },
  };
}
